export default "__VITE_ASSET__M7gD8uul__"